// Dependencies
import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

import {
  BackImage,
  CheckLogin,
  CollectionView,
  ContactView,
  DirectoryNewView,
  ExhibitionView,
  FastFactsView,
  FavoriteView,
  Header,
  HomeView,
  MessageCenter,
  MobileWarning,
  NotFoundView,
  NotLoggedInView,
  ProfileViewNew,
  RetainContentView,
  RetainView,
  RewardsView,
  Search,
  SearchView,
  ShowcaseCollectionView,
  ShowcaseCollectionCountryView,
  SubAppView,
  ToolboxView,
  TrainingContentView,
  TrainingView,
  WebsiteSplitter,
} from 'C4';

const loginPages = ['training', 'retain'];
const paths = `(${loginPages.join('|')})`;

const SubRouter = () => (
  <div className="subRouter" id="container">
    <Route path={`/main/${paths}`} render={() => <CheckLogin />} />
    <Route
      path="/main/"
      render={(routerProps) => {
        const { pathname } = routerProps.location;
        if (pathname.includes('main/training/chapter/')) {
          return null;
        }
        if (pathname.includes('main/fasttrack/chapter/')) {
          return null;
        }
        if (pathname.includes('main/directory')) {
          return null;
        }
        if (pathname.includes('main/sell/directory')) {
          return null;
        }
        return <Header pathname={pathname} />;
      }}
    />
    <div className="viewContainer">
      <BackImage />
      <Switch>
        ]
        <Route path="/main" exact component={HomeView} />
        <Route path="/main/landing" exact component={HomeView} />
        <Route path="/main/hotel-showroom" exact component={ExhibitionView} />
        <Route path="/main/hotel-showroom/:category/:countryName" component={ShowcaseCollectionCountryView} />
        <Route path="/main/hotel-showroom/:category" component={ShowcaseCollectionView} />
        <Route path="/main/mob" exact component={MobileWarning} />
        <Route path="/main/sell/contact" exact component={ContactView} />
        <Route path="/main/training" exact component={TrainingView} />
        <Route path="/main/ret" exact component={RetainView} />
        <Route path="/main/ret/chapter" exact render={() => <Redirect to="/main/ret" />} />
        <Route path="/main/retain" exact component={RetainView} />
        <Route path="/main/retain/chapter/:chapterId/:pageId" exact component={RetainContentView} />
        <Route
          path="/main/:pageType/chapter/:chapterId/:pageId"
          render={(props) => {
            const { pageType, pageId } = props.match.params;
            switch (pageType) {
              case 'ret':
                return <RetainContentView key={pageId} {...props} />;
              case 'training':
              case 'fasttrack':
                return (
                  <TrainingContentView
                    key={pageId}
                    redirPath={`/main/${pageType}/chapter/`}
                    type={pageType}
                    {...props}
                  />
                );
              default:
                return null;
            }
          }}
        />
        <Route path="/main/favorites" exact component={FavoriteView} />
        <Route path="/main/promote" exact component={FastFactsView} />
        <Route path="/main/sell" exact component={ToolboxView} />
        <Route path="/main/subApp" exact component={SubAppView} />
        <Route path="/main/directory" exact component={DirectoryNewView} />
        <Route path="/main/sell/directory" exact component={DirectoryNewView} />
        <Route path="/main/messages" exact component={MessageCenter} />
        <Route path="/main/rewards" exact component={RewardsView} />
        <Route path="/main/landing/messages" exact component={MessageCenter} />
        <Route path="/main/promote/videos/:videoId?" component={CollectionView} />
        <Route path="/main/promote/images/:imageId?" component={CollectionView} />
        <Route path="/main/sell/videoLibrary/:videoId?" component={CollectionView} />
        <Route path="/main/sell/imageLibrary/:imageId?" component={CollectionView} />
        <Route path="/main/(sell|promote)/:category/:item?" component={CollectionView} />
        {/* <Route path="/main/search" component={Search} /> */}
        <Route path="/main/off" component={NotLoggedInView} />
        <Route path="/main/splitter/:itemId/:type" component={WebsiteSplitter} />
        <Route path="/main/search" component={SearchView} />
        <Route component={NotFoundView} />
      </Switch>
    </div>
    {/* <Footer /> */}
  </div>
);

export default withRouter(SubRouter);
